// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */
body {
    font-family: 'Arial', sans-serif;
    background-color: #f4f4f4;
    margin: 0;
    padding: 0;
  }
  
  /* Dashboard Container */
  .dashboard-container {
    display: flex;
  }
  
  /* Sidebar */
  .sidebar {
    width: 250px;
    background-color: #007bff;
    color: #ffffff;
    height: 100vh;
    position: fixed;
    padding: 20px;
    transition: all 0.3s;
  }
  
  .sidebar-title {
    font-size: 1.5em;
    font-weight: bold;
  }
  
  .sidebar-menu {
    list-style: none;
    padding: 0;
    margin-top: 20px;
  }
  
  .menu-item {
    padding: 10px 0;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .menu-item:hover {
    background-color: #0056b3;
  }
  
  /* Dashboard Content */
  .dashboard-content {
    margin-left: 270px;
    padding: 20px;
    width: calc(100% - 270px);
  }
  
  /* Header */
  .dashboard-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
  }
  
  .header-right {
    display: flex;
    gap: 10px;
  }
  
  /* Stats Cards */
  .stats-cards {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
  }
  
  .card {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    flex: 1 1;
    padding: 20px;
    transition: transform 0.2s;
  }
  
  .card:hover {
    transform: translateY(-5px);
  }
  
  .card h4 {
    margin-bottom: 15px;
  }
  
  /* Dashboard Panels */
  .dashboard-section {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
  }
  
  .dashboard-panel {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    flex: 1 1;
    transition: transform 0.2s;
  }
  
  .dashboard-panel:hover {
    transform: translateY(-5px);
  }
  
  .btn.logout-button {
    background-color: #ff3d00;
    color: #ffffff;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .btn.logout-button:hover {
    background-color: #e63946;
  }
  `, "",{"version":3,"sources":["webpack://./src/dashboard/styles/Dashboard.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,gCAAgC;IAChC,yBAAyB;IACzB,SAAS;IACT,UAAU;EACZ;;EAEA,wBAAwB;EACxB;IACE,aAAa;EACf;;EAEA,YAAY;EACZ;IACE,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,eAAe;IACf,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE,kBAAkB;IAClB,aAAa;IACb,yBAAyB;EAC3B;;EAEA,WAAW;EACX;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,SAAO;IACP,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA,qBAAqB;EACrB;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,SAAO;IACP,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":["/* Global Styles */\nbody {\n    font-family: 'Arial', sans-serif;\n    background-color: #f4f4f4;\n    margin: 0;\n    padding: 0;\n  }\n  \n  /* Dashboard Container */\n  .dashboard-container {\n    display: flex;\n  }\n  \n  /* Sidebar */\n  .sidebar {\n    width: 250px;\n    background-color: #007bff;\n    color: #ffffff;\n    height: 100vh;\n    position: fixed;\n    padding: 20px;\n    transition: all 0.3s;\n  }\n  \n  .sidebar-title {\n    font-size: 1.5em;\n    font-weight: bold;\n  }\n  \n  .sidebar-menu {\n    list-style: none;\n    padding: 0;\n    margin-top: 20px;\n  }\n  \n  .menu-item {\n    padding: 10px 0;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .menu-item:hover {\n    background-color: #0056b3;\n  }\n  \n  /* Dashboard Content */\n  .dashboard-content {\n    margin-left: 270px;\n    padding: 20px;\n    width: calc(100% - 270px);\n  }\n  \n  /* Header */\n  .dashboard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 20px;\n  }\n  \n  .header-right {\n    display: flex;\n    gap: 10px;\n  }\n  \n  /* Stats Cards */\n  .stats-cards {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 20px;\n  }\n  \n  .card {\n    background-color: #ffffff;\n    border-radius: 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    flex: 1;\n    padding: 20px;\n    transition: transform 0.2s;\n  }\n  \n  .card:hover {\n    transform: translateY(-5px);\n  }\n  \n  .card h4 {\n    margin-bottom: 15px;\n  }\n  \n  /* Dashboard Panels */\n  .dashboard-section {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 20px;\n  }\n  \n  .dashboard-panel {\n    background-color: #ffffff;\n    border-radius: 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    flex: 1;\n    transition: transform 0.2s;\n  }\n  \n  .dashboard-panel:hover {\n    transform: translateY(-5px);\n  }\n  \n  .btn.logout-button {\n    background-color: #ff3d00;\n    color: #ffffff;\n    border: none;\n    padding: 10px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .btn.logout-button:hover {\n    background-color: #e63946;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
